import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersByEmailCampaignQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsUsersByEmailCampaignTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsUsersByEmailCampaignQuery({
    variables: { filter: filter as never, limit },
  });

  const rows = (data?.analyticsUsers.usersByEmailCampaign ?? []).map((row) => [
    row.title || t("shared.attribution.deletedCampaign"),
    formatNumber(row.users),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.users.tableByEmailCampaign")}
      columns={[
        { name: t("analytics.columnEmailCampaign"), minWidth: 200 },
        { name: t("analytics.users.columnUsers") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.UsersByEmailCampaignType}
          filter={filter}
        />
      }
    />
  );
};
